import React, { useCallback } from 'react';
import { Box, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { subscriptionAdminApi } from '../../subscriptionAdmin/api';
import { useAdminFetch } from '../hooks/useAdminFetch';

export default function AuditTab() {
  const fetchLogs = useCallback(() => subscriptionAdminApi.listAuditLogs(), []);
  const { data, loading, error } = useAdminFetch(fetchLogs);
  const logs = Array.isArray(data) ? data : [];

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }
  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  return (
    <Box sx={{ overflowX: 'auto', bgcolor: 'white', borderRadius: 2, boxShadow: 1 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Action</TableCell>
            <TableCell>Resource</TableCell>
            <TableCell>Actor</TableCell>
            <TableCell>At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {logs.map((log) => (
            <TableRow key={log._id}>
              <TableCell>{log.action || '—'}</TableCell>
              <TableCell>{log.resource || log.entityType || '—'}</TableCell>
              <TableCell>{String(log.actorId || log.adminId || '').slice(-8) || '—'}</TableCell>
              <TableCell>{log.createdAt ? new Date(log.createdAt).toLocaleString() : '—'}</TableCell>
            </TableRow>
          ))}
          {!logs.length && (
            <TableRow>
              <TableCell colSpan={4} align="center" sx={{ py: 4, color: '#64748b' }}>
                No audit entries.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Box>
  );
}
